var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1333 14C25.1333 21.2458 19.667 27 13.0667 27C6.46629 27 1 21.2458 1 14C1 6.7542 6.46629 1 13.0667 1C19.667 1 25.1333 6.7542 25.1333 14Z",
    stroke: "#717070",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89853 18.0764L14.8912 8.30542L18.1874 11.3065L9.14125 21.2729L5.59766 21.7963L5.89853 18.0764Z",
    fill: "#717070",
    stroke: "#717070",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4727 7.11349L18.2114 3.79492L21.9002 7.36295L19.1267 10.6815L15.4727 7.11349Z",
    fill: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.898 20.1852L9.11864 21.2251L5.56836 21.8323L5.98289 18.1682L6.86545 18.2659V19.0197V19.1662H7.00586H7.8483L7.88841 20.0387V20.1573H8.00207L8.898 20.1852Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71689 21.6638L8.95961 21.1055L8.79246 20.3168L7.74275 20.254L7.68927 19.2769L6.69973 19.3118V18.3836L6.07125 18.3138L5.71689 21.6569V21.6638ZM5.41602 22.0198L5.89741 18.0137L7.02735 18.1323V19.0187L7.99682 18.9838L8.04363 19.9888L9.0599 20.0446L9.28054 21.3218L5.41602 22.0198Z",
    fill: "#717070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77818 20.4497L6.97498 21.5315L5.59766 21.7897L5.77818 20.4497Z",
    fill: "#717070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.40e24c346ae16bc21b89dfc789af818c.svg";
export { ForwardRef as ReactComponent };